<div routerLink="/category/{{data?.id}}" (click)="ngOnInit()" style="cursor: pointer;"
    class="bg-opacity-75 bg-light h-100 d-flex align-items-center py-3 px-5 text-dark text-opacity-75 text-center">
    <img *ngIf="checkisImg(data?.image); else elseBlock" src="{{staticURL}}{{data?.image}}" class="img-fluid"
        style="height: 50px" alt="{{data?.name}}">
    <ng-template #elseBlock>
        <i class="{{data?.image}}"></i>
        <span>{{data?.name}}</span>
    </ng-template>
</div>

<span class="bg-btn-color bg-light bg-opacity-75">
    <i class="pi pi-times times-css" [routerLink]="data?.parent?.id ? '/category/' + data?.parent?.id : '/home'"></i>
</span>
<div class="d-flex flex-row-reverse align-items-center gap-4 h-100" app-list-ous *ngIf="data?.parent"
    [data]="data?.parent"></div>